import { createInertiaApp, router } from "@inertiajs/react";
import { createElement, Fragment } from "react";
import { createRoot } from "react-dom/client";
import posthog from "../posthog";

const posthogDebug = import.meta.env.VITE_PUBLIC_POSTHOG_DEBUG === "true";

createInertiaApp({
  resolve: async (name) => {
    const pages = import.meta.glob("../pages/**/*.jsx", {
      eager: false,
    });
    const page = await pages[`../pages/${name}.jsx`]();
    if (!page) {
      console.error(`Missing Inertia page component: '${name}.jsx'`);
    }
    return page;
  },

  setup({ el, App, props }) {
    if (el) {
      createRoot(el).render(
        createElement(Fragment, null,
          createElement(App, props)
        )
      );

      // Wait a brief moment for PostHog to fully initialize
      setTimeout(() => {
        if (posthogDebug) {
          console.log("[PostHog] Sending test event...");
        }

        // Send a test event
        posthog.capture("test_event", {
          timestamp: new Date().toISOString(),
          source: "initial_load",
        });

        // Send pageview
        posthog.capture("$pageview", {
          $current_url: window.location.href,
        });

        if (posthogDebug) {
          console.log("[PostHog] Initial events sent");
          console.log(
            "[PostHog] Check Network tab for requests to:",
            posthog.config?.api_host
          );
        }
      }, 500);
    } else {
      console.error(
        "Missing root element.\n\n" +
          "If you see this error, it probably means you load Inertia.js on non-Inertia pages.\n" +
          'Consider moving <%= vite_javascript_tag "inertia" %> to the Inertia-specific layout instead.'
      );
    }
  },
});

// Capture navigation events
router.on("navigate", (event) => {
  if (posthogDebug) {
    console.log("[PostHog] Navigation event detected");
  }
  posthog.capture("$pageview", {
    $current_url: window.location.href,
  });
});
